import { useEffect } from 'react'
import type { PropsWithChildren } from 'react'

import { useSession } from '@/core/auth/hooks/useSession'
import { sessionService } from '@/core/auth/session/session.service'
import { authService } from '@/features/auth/services/auth.service'

/**
 * Guard for the /login route only.
 *
 * Unlike GuestGuard (which redirects authenticated users to /dashboard),
 * this guard clears any active session when the user lands on the login page,
 * forcing a fresh authentication regardless of prior state.
 */
export function LoginGuard({ children }: PropsWithChildren) {
  const { isAuthenticated } = useSession()

  useEffect(() => {
    if (isAuthenticated) {
      sessionService.clearSession()
      void authService.logout()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <>{children}</>
}
